import React from 'react';
import classes from "./SubscribePage.module.css";
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FaChevronRight, FaCopyright } from 'react-icons/fa6';
import { useState } from 'react';
import { useEffect } from 'react';
import { v4 as uuidv4 } from "uuid";
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { loginApi, SendOtpAPI } from '../api/api';
import { useAppDispatch, useAppSelector } from '../Store/hooks';
import BackgroundLayout from '../Components/BackgroundLayout';
import { motion, useAnimationControls } from "framer-motion";
import { InputText } from 'primereact/inputtext';
import Spinner from '../Components/Loaders/Spinner';
import { setUser } from '../Slices/userSlice';

const LoginPage = () => {
    const [msisdn, setMsisdn] = useState("");
    const [loading, setLoading] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams() as any;
    const [extRef, setExtRef] = useState(null);
    const navigate = useNavigate();

    const { user } = useAppSelector(state => state.userSlice);
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (user) {
            navigate("/home");
        }
    }, []);

    useEffect(() => {
        if (searchParams.get("ext_id")) {
            setExtRef(searchParams.get("ext_id"));
        } else {
            setSearchParams({ ext_id: uuidv4() });
        }
    }, [searchParams]);

    const handleFormSubmission = async (e: any) => {
        try {
            e.preventDefault();
            if (msisdn?.trim().length == 0) {
                return;
            }
            setLoading(true);

            let msisdnWithCountryCode = msisdn?.toString().trim().replace(/\D/g, '');

            if (msisdnWithCountryCode.startsWith('0')) {
                msisdnWithCountryCode = msisdnWithCountryCode.slice(1);
            }

            if (!msisdnWithCountryCode.startsWith('94')) {
                msisdnWithCountryCode = '94' + msisdnWithCountryCode;
            }

            const response = await loginApi(msisdnWithCountryCode);
            dispatch(setUser(response?.data?.result));
            console.log(response, 'response');
            setLoading(false);
            toast.success("Login Successfully!");
            navigate("/home");
        } catch (error: any) {
            setLoading(false);
            console.log(error?.response?.data?.error?.status, 'error');
            if (error?.response?.data?.error?.status == 0) {
                toast.error("You are not Subscribed!");
            }
            else if (error?.response?.data?.error?.status == 1) {
                toast.error("Low Balance!");
            }
            else {
                toast.error("Something Went Wrong! Try Again!");
            }
        }
    }

    const variants = {
        hidden: {
            opacity: 0,
            scale: 0,
        },
        visible: {
            opacity: 1,
            scale: 1,
        },
    };

    const controls = useAnimationControls();

    useEffect(() => {
        controls.start("visible");
    }, []);

    return (
        <BackgroundLayout style={{padding:0}}>
            <motion.div
                layout
                variants={variants}
                initial="hidden"
                animate={controls}
                transition={{
                    type: "spring",
                    stiffness: 700,
                    damping: 30,
                }}
                className={classes.auth_modal}
            >
                <div className={classes.auth_sub_modal}>
                    <motion.div className={classes.form_modal}>
                        <img src="/assets/images/logo2.png" alt="uvmovie" className={classes.logo} />
                        {/* <p className={classes.title}>Subscribe Service</p> */}

                        <form className={classes.form} onSubmit={handleFormSubmission}>
                            <InputText
                                required
                                type="number"
                                className={`p-inputtext-lg ${classes.input}`}
                                placeholder="Sri Lankan Mobile Number"
                                value={msisdn}
                                onChange={(e) => setMsisdn(e.target.value)}
                            />

                            <button
                                type="submit"
                                disabled={loading}
                                className={classes.signup_btn}
                            >
                                {loading ? (
                                    <div
                                        style={{
                                            width: "100%",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Spinner />
                                    </div>
                                ) : (
                                    "Login"
                                )}
                            </button>

                            <div className={classes.grid_container}>
                                <span className={classes.grid_item}></span>
                                <span className={classes.or}>Or</span>
                                <span className={classes.grid_item}></span>
                            </div>

                            <p className={classes.link_text}>
                                New User!{" "}
                                <span
                                    className={classes.link}
                                    onClick={() => {
                                        navigate(`/?ext_ref=${extRef}`)
                                    }}
                                >
                                    Subscribe Service
                                </span>
                            </p>

                        </form>
                    </motion.div>
                    <div className={classes.benefits_modal}>
                        <p className={classes.benefits_title}>Benefits of Service</p>

                        <div className={classes.benefits}>
                            <div className={classes.benefit}>
                                <div className={classes.benefit_title}>
                                    <i className={`pi pi-circle-fill ${classes.icon}`} />
                                    <p className={classes.bt}>Large Community</p>
                                </div>
                                <p className={classes.bd}>
                                    Interact with the large community and know what is trending.
                                </p>
                            </div>

                            <div className={classes.benefit}>
                                <div className={classes.benefit_title}>
                                    <i className={`pi pi-circle-fill ${classes.icon}`} />
                                    <p className={classes.bt}>Watch Shortz</p>
                                </div>
                                <p className={classes.bd}>
                                    Watch the shortz (clips) of movies and series.
                                </p>
                            </div>

                            <div className={classes.benefit}>
                                <div className={classes.benefit_title}>
                                    <i className={`pi pi-circle-fill ${classes.icon}`} />
                                    <p className={classes.bt}>Your watchlist</p>
                                </div>
                                <p className={classes.bd}>
                                    Create your personalised watchlist of movies.
                                </p>
                            </div>

                            <div className={classes.benefit}>
                                <div className={classes.benefit_title}>
                                    <i className={`pi pi-circle-fill ${classes.icon}`} />
                                    <p className={classes.bt}>Ratings</p>
                                </div>
                                <p className={classes.bd}>
                                    Rate and remember eveything you've seen.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </motion.div>

        </BackgroundLayout>
    )
}

export default LoginPage